import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as coreMiddlewares from 'hub-http/middlewares/core';
import appAuthStack from 'hub-http/stacks/hubapi';
import noAuthStack from 'hub-http/stacks/noAuthWithCredentialsHubapi';
export const profilesAppClient = promiseClient(createStack(coreMiddlewares.base('marketplace/profiles/v1/'), appAuthStack));
export const profilesPublicClient = promiseClient(createStack(coreMiddlewares.base('marketplace/profiles/public/v1/'), noAuthStack));